import React from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

class CustomTypeahead extends React.Component {
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    noFormGroup: PropTypes.bool,
    required: PropTypes.bool,
    ajaxErrors: PropTypes.object,
    t: PropTypes.func,
    multiple: PropTypes.bool
  };

  render() {
    const {
      errors,
      name,
      label,
      help,
      noFormGroup,
      required,
      multiple,
      loading
    } = this.props;

    let propsClone = { ...this.props };
    delete propsClone.name;
    delete propsClone.multiple;

    return (
      <div
        className={
          errors[name]
            ? (noFormGroup ? "" : "form-group m-form__group ") + "has-danger"
            : noFormGroup
            ? ""
            : "form-group m-form__group "
        }
      >
        {label && (
          <label htmlFor={name}>
            <Trans>{label}</Trans> {required ? "*" : ""}
          </label>
        )}
        <AsyncTypeahead
          multiple={!!multiple}
          isLoading={loading === undefined ? false : loading}
          minLength={2}
          inputProps={{ name, autoComplete: 'off' }}
          {...propsClone}
        />
        {help && (
          <span className="m-form__help">
            <Trans>{help}</Trans>
          </span>
        )}
        {errors[name] && (
          <div className="form-control-feedback">
            <Trans>{errors[name]}</Trans>
          </div>
        )}
      </div>
    );
  }
}

export default CustomTypeahead;
